import pluralize from 'pluralize';

import { Text } from '@/components/text';

interface Props {
  dateLabel: string;
  frequency: number;
  frequencyLabel: string;
  showSearchPrompt?: boolean;
}

const BarTooltip = ({ dateLabel, frequency, frequencyLabel, showSearchPrompt = false }: Props) => {
  return (
    <div className="m-2 text-left">
      <Text variant="secondary" className="m-0 font-semibold">
        {dateLabel}
      </Text>
      <Text variant="sm" className="m-0">
        {frequency} {pluralize('departure', frequency)} {frequencyLabel}
      </Text>
      {showSearchPrompt && (
        <Text variant="sm" className="m-0 mt-1 italic text-grey-400">
          Click to see schedules for this date
        </Text>
      )}
    </div>
  );
};

export { BarTooltip };
